<template>
  <div class="tab_container">
    <div :class="renderButtonStyling" @click="switchStyling()">
      <span class="placeholder-text"> {{ text }}</span>
      <div class="bottom-arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PatientEnrollmentTabBar",
  components: {},
  data() {
    return {
      tabIndex: null,
    };
  },
  props: {
    text: {
      type: String,
      default: "",
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    renderButtonStyling() {
      return this.active ? "primary-tab" : "secondary-tab";
    },
  },
  methods: {
    switchStyling() {
      if (!this.active) {
        this.$emit("switch-tab");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vcore_col--md--12 {
  margin: 0;
}

.tab_container {
  margin-top: 15px;
  margin-bottom: 15px;

  .placeholder-text {
    text-align: center;
  }

  .primary-tab {
    height: 90px;
    background: linear-gradient(270deg, #0b5637 0%, #4fa800 100%);

    @media all and (max-width: $grid-breakpoint-sm) {
      height: 65px;
    }

    span {
      color: #fff;
      font-family: Poppins;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      @media all and (max-width: $grid-breakpoint-lg) {
        font-size: min(14px, 32px);
      }
    }

    .bottom-arrow {
      position: relative;
      left: 50%;
      width: 55px;
      height: 55px;
      transform: translate(-50%, -53%) rotate(45deg);
      z-index: -1;
      background: linear-gradient(315deg, #0b5637 0%, #4fa800 100%);

      @media all and (max-width: $grid-breakpoint-sm) {
        width: 22px;
        height: 22px;
      }
    }
  }

  .secondary-tab {
    height: 90px;
    background: var(--shades-white-ffffff, #fff);
    border: 1px solid var(--primary-light-green-100, #4fa700);
    cursor: pointer;

    @media all and (max-width: $grid-breakpoint-sm) {
      height: 65px;
    }

    &:hover {
      background: var(--primary-light-green-10, #edf6e5);
    }

    span {
      color: var(--primary-light-green-100, #4fa700);
      font-family: Poppins;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      @media all and (max-width: $grid-breakpoint-lg) {
        font-size: min(14px, 32px);
      }
    }
  }
}
</style>
